import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const match = /session_id=([^&]+)/.exec(hash);
    const sid = match ? decodeURIComponent(match[1]) : null;
    if (!sid) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sid });
        if (data?.user?.active_org_id) localStorage.setItem("gc_active_org", data.user.active_org_id);
        toast.success("Berhasil masuk dengan Google");
        window.history.replaceState(null, "", "/app");
        window.location.assign("/app");
      } catch (err) {
        toast.error(formatErr(err));
        navigate("/login");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex items-center gap-3 text-slate-600">
        <Loader2 className="w-5 h-5 animate-spin text-emerald-500" />
        <span className="font-medium">Menyelesaikan proses masuk…</span>
      </div>
    </div>
  );
}
